<template>

    <div :class="{'h-screen' : embeded_widget == 'true' , 'md:h-[99.99%]' : embeded_widget == 'false' }">
      <div class="md:h-[99.99%]">
        <section :class="{'md:h-[99.99%]' : embeded_widget == 'true' , 'md:h-[99.99%] md:min-h-[99.99%]' : embeded_widget == 'false' }" class="flex justify-center items-center md:p-4 w-full md:overflow-hidden">
        <div id="timelydo_public_event_card" :class="mainCardStyles" class="flex-grow bg-white md:h-[99.99%] overflow-hidden md:rounded-lg transition transition-all duration-500 md:shadow-lg shadow-gray-300 dark:shadow-gray-600/40 dark:bg-[#1C2128] dark:border-gray-500">
          <div  class="w-full md:flex  md:h-[100%]">
            <div class="border-b pb-5 w-full md:w-2/5 md:flex flex-col h-full md:h-[99.9%] flex-grow md:border-b-0 md:border-r dark:border-gray-500">
              <div :class="{ 'md:block items-start': profile_pic === 'false' }" class="w-full">
                <div class="flex flex-col">
                  <div id="timelydo_public_event_banner" v-if="custom_template.banner_style === 'color' || custom_template.banner_style === 'custom_color'" :style="{ background: 'linear-gradient(to right, ' + custom_template.banner_max_color_code + ', ' + custom_template.banner_min_color_code + ', ' + custom_template.banner_max_color_code + ')' }" class="h-32 flex-shrink-0">
                    <a v-if="current_event.is_public || showForm" @click="backIconLink" class="ml-5 mt-5 cursor-pointer place-self-start absolute p-1.5 border fill-white hover:bg-white hover:fill-blue-600 rounded-full inline-block dark:fill-white dark:hover:bg-gray-500">
                      <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
                      </svg>
                    </a>
                  </div>
                  <div v-else>
                    <div id="timelydo_public_event_banner" v-if="custom_template.banner_style === 'image' || custom_template.banner_style === 'custom_image'" class="w-full h-32">
                      <a v-if="current_event.is_public || showForm" @click="backIconLink" class="ml-5 mt-5 cursor-pointer place-self-start absolute p-1.5 border fill-gray-200 hover:bg-white hover:fill-blue-600 rounded-full inline-block dark:fill-white dark:hover:bg-gray-500">
                        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
                        </svg>
                      </a>
                      <img v-if="custom_template.banner_style === 'image'" :src="custom_template.banner_image_url" class="w-full h-full">
                      <img v-if="custom_template.banner_style === 'custom_image'" :src="custom_template.custom_profile_banner.image_url" class="w-full h-full">
                    </div>
                  </div>
                  <div class="w-full relative flex flex-col">
                    <div id="timelydo_public_event_banner" v-if="custom_template.banner_style === 'no_banner'" class="absolute left-1 top-1">
                      <a v-if="current_event.is_public || showForm" @click="backIconLink" class="ml-5 mt-5 cursor-pointer place-self-start absolute p-1.5 border fill-gray-700 hover:bg-blue-600 hover:fill-white rounded-full inline-block dark:fill-white dark:hover:bg-gray-500">
                        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
                        </svg>
                      </a>
                    </div>
                    <div v-if="current_event.creator.show_message_button_on_events" class="absolute right-0">
                       
                      <public-message-form :host_id="current_event.creator.id"
                                           :current_attendee="current_attendee"
                                           show_location="profile"></public-message-form>
                    </div>

                    <div id="timelydo_event_profile_picture" class="p-0.5 bg-white w-fit mx-auto  rounded-full dark:bg-[#1C2128]" :class="{'mt-8' : custom_template.banner_style === 'no_banner' , '-mt-12' : custom_template.banner_style !== 'no_banner' }">
                      <a :href="profileHref" class="flex-shrink-0">
                        <img :src="profile_pic" alt="profile picture" title="profile picture" class="h-24 w-24 mx-auto border mb-2 hover:border-gray-400 rounded-full p-0.5" v-if="profile_pic !== 'false'" />
                        <div class="h-24 w-24 text-gray-600 flex justify-center text-2xl font-medium bg-gray-200 items-center  mx-auto border-[3px] mb-2 border-gray-300 hover:border-gray-500 rounded-full p-0.5" v-if="profile_pic === 'false'">
                          {{ current_event.creator_avatar_name }}
                        </div>  
                      </a>
                    </div>
                  </div>
                  <div class="text-gray-700 z-10 -mt-5 text-center dark:text-gray-400">
                    <p id="timelydo_event_host_name" class="z-10 text-gray-500 font-semibold tracking-wide mt-3 dark:text-gray-400">{{ current_event.creator.full_name }}</p>
                  </div>
                  <div id="timelydo_event_host_social_links" class="flex flex-col items-center justify-center mx-auto md:pr-0">           
                    
                    <div v-if="social_library_list.show_on_public_events">
                        <SocialIcons :social_library="social_library"></SocialIcons>
                    </div>
                  </div>
                 
                </div>
                  
                <div class="md:text-left px-5 text-center place-self-center mx-auto">
                
                  <p id="timelydo_public_event_name" class="font-semibold text-lg mt-1.5 text-gray-700 tracking-tight break-all dark:text-gray-400">{{ current_event.name }}</p>
                </div>
              </div>
              
              <div class="flex px-5 justify-center overflow-y-auto scrollbar-style flex-col w-11/12 mx-auto md:w-full md:block md:gap-0 sm:gap-x-7 sm:gap-y-1 my-2 md:my-0 tracking-wide">
                <p class="timelydo-public-event-icons flex items-center text-sm mt-2 font-semibold gap-2 text-gray-700 fill-gray-600 dark:text-gray-400 ">
                  <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>
                    </svg>
                  </span>
                  
                  {{ current_event.ui_slot_duration }}
                </p>

                <p class="timelydo-public-event-icons flex sm:items-center md:items-start text-sm mt-1.5 font-semibold gap-2 text-gray-700 fill-gray-600 dark:text-gray-400 dark:text-gray-400"
                   v-if="showForm">
                   <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  

                      <svg class="h-4 w-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-supported-dps="24x24" focusable="false"><path d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"/></svg>
                   </span>
                 
                  {{ booking_details.selected_slot[attendee.time_format]['start_at'] }} - {{ booking_details.selected_slot[attendee.time_format]['end_at'] }}, {{ uiDate }}
                </p>
                
                
                <p class="timelydo-public-event-icons flex items-center text-sm mt-1.5 font-semibold gap-2 text-gray-700 fill-gray-600 dark:text-gray-400 dark:text-gray-400">
                  <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  
  
                    <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/>
                    </svg>
                  </span>
                  (GMT {{attendee.timezone.offset}}) {{ attendee.timezone.name }}
                </p>
                
                <p class="timelydo-public-event-icons flex items-center text-sm mt-1.5 font-semibold gap-2 text-gray-700 fill-gray-600 dark:text-gray-400 dark:text-gray-400">
                  <!-- for phone -->
                  <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  

                    <svg v-if="current_event.location.name === 'phone_call'" class="h-[16px] w-[16px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/></svg>
                    <!-- locaion -->
                    <svg v-else class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>
                  </span>
                  {{ current_event.humanize_location_name}}
                  <span v-if="current_event.location.name === 'phone_call' && current_event.location.phone_call.selected_option === 'invitee_should_call_host'">
                      ({{ current_event.location.phone_call.host_contact_number }})
                  </span>
                </p>

                 <p id="timelydo_public_event_inperson_details" v-if="current_event.location.name === 'in_person'" class="mt-1.5 text-sm w-11/12 mx-auto md:w-full dark:text-gray-400">
                      {{ current_event.location.in_person.details }}
                 </p>              
               
                <div id="timelydo_public_event_reschedule_section" class="mt-8" v-if="reschedule === 'true'">
                    <b class="flex sm:items-center md:items-start text-sm font-semibold gap-2 text-zinc-500 fill-zinc-500 dark:text-gray-400 dark:text-gray-400">{{ I18N.application.bookings.upcoming.former_time }}</b>
                    <p class="flex sm:items-center md:items-start text-sm mt-2 font-semibold gap-2 text-gray-700 fill-gray-600" :class="{'line-through': showForm}">
                      <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                          <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/>
                        </svg>
                      </span>
                     {{ parsed_rescheduling_data.attendee_ui_booking_range_with_date }}
                    </p>
                    
                    
                    <p class="flex items-center text-sm mt-2 font-semibold gap-2 text-gray-700 fill-gray-600 dark:text-gray-400 dark:text-gray-400" :class="{'line-through': showForm}">
                      <span class="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-blue-500 fill-white rounded-full">  
                        <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/>
                        </svg>
                      </span>
                     {{ parsed_rescheduling_data.attendee_timezone }}
                    </p>
                
                </div>
                <p id="timelydo_public_event_description" class="mt-3 text-sm w-full text-gray-700 dark:text-gray-400" v-html="current_event.formatted_description" ></p>

              </div>

              <div class="px-5 hidden md:flex justify-between items-center mt-auto">
                <div>
                    <div v-if="current_event.creator.enable_branding">
                        <div v-if="branding.logo_url != null && branding.logo_url != undefined && branding.logo_url != ''">
                            <a v-if="branding.website_url" :href="branding.website_url">
                              <img class="max-h-8" :src="branding.logo_url">
                            </a>
                            <img v-else class="max-h-8" :src="branding.logo_url">
                        </div>
                        <div v-else>
                            <a href="/" target="_parent">
                              <svg class="h-7 dark:hidden" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" zoomAndPan="magnify" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="54.57 148.46 139.82 38.29">
                                <defs>
                                  <g/>
                                  <clipPath id="5648ea7847">
                                    <path d="M 54.613281 148.5 L 92.863281 148.5 L 92.863281 186.75 L 54.613281 186.75 Z M 54.613281 148.5 " clip-rule="nonzero"/>
                                  </clipPath>
                                </defs>
                                <g clip-path="url(#5648ea7847)">
                                  <path fill="#2563eb" d="M 84.6875 186.699219 L 62.703125 186.699219 C 58.210938 186.699219 54.570312 183.058594 54.570312 178.566406 L 54.570312 156.59375 C 54.570312 152.101562 58.210938 148.457031 62.703125 148.457031 L 84.679688 148.457031 C 89.171875 148.457031 92.8125 152.101562 92.8125 156.59375 L 92.8125 178.566406 C 92.8125 183.058594 89.171875 186.699219 84.6875 186.699219 Z M 84.6875 186.699219 " fill-opacity="1" fill-rule="nonzero"/>
                                </g>
                                <path fill="#ffffff" d="M 71.726562 162.816406 L 65.988281 162.816406 L 65.988281 159.667969 L 81.410156 159.667969 L 81.410156 162.816406 L 75.6875 162.816406 L 75.6875 175.976562 L 71.726562 175.976562 Z M 71.726562 162.816406 " fill-opacity="1" fill-rule="nonzero"/>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(98.801842, 175.900008)">
                                    <g>
                                      <path d="M 11.5625 -16.25 L 11.203125 -14.09375 L 7.171875 -14.09375 L 7.171875 0 L 4.34375 0 L 4.34375 -14.09375 L 0.234375 -14.09375 L 0.234375 -16.25 Z M 11.5625 -16.25 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(110.628051, 175.900008)">
                                    <g>
                                      <path d="M 4.078125 0.09375 C 3.234375 0.09375 2.585938 -0.15625 2.140625 -0.65625 C 1.691406 -1.164062 1.46875 -1.816406 1.46875 -2.609375 L 1.46875 -11.953125 L 4.203125 -11.953125 L 4.203125 -2.859375 C 4.203125 -2.484375 4.253906 -2.234375 4.359375 -2.109375 C 4.472656 -1.984375 4.644531 -1.921875 4.875 -1.921875 C 4.9375 -1.921875 5.003906 -1.921875 5.078125 -1.921875 C 5.148438 -1.921875 5.21875 -1.925781 5.28125 -1.9375 C 5.34375 -1.9375 5.414062 -1.945312 5.5 -1.96875 L 5.78125 -0.234375 C 5.664062 -0.171875 5.523438 -0.117188 5.359375 -0.078125 C 5.210938 -0.0234375 5.03125 0.015625 4.8125 0.046875 C 4.59375 0.078125 4.347656 0.09375 4.078125 0.09375 Z M 2.875 -17.28125 C 3.382812 -17.28125 3.773438 -17.128906 4.046875 -16.828125 C 4.328125 -16.523438 4.46875 -16.128906 4.46875 -15.640625 C 4.46875 -15.160156 4.328125 -14.757812 4.046875 -14.4375 C 3.765625 -14.125 3.351562 -13.96875 2.8125 -13.96875 C 2.300781 -13.96875 1.90625 -14.125 1.625 -14.4375 C 1.34375 -14.75 1.203125 -15.128906 1.203125 -15.578125 C 1.203125 -16.066406 1.34375 -16.472656 1.625 -16.796875 C 1.90625 -17.117188 2.320312 -17.28125 2.875 -17.28125 Z M 2.875 -17.28125 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(116.769042, 175.900008)">
                                    <g>
                                      <path d="M 15.265625 0 L 15.265625 -7.828125 C 15.265625 -8.492188 15.160156 -9.023438 14.953125 -9.421875 C 14.742188 -9.816406 14.382812 -10.015625 13.875 -10.015625 C 13.570312 -10.015625 13.265625 -9.925781 12.953125 -9.75 C 12.640625 -9.582031 12.351562 -9.335938 12.09375 -9.015625 C 11.84375 -8.703125 11.632812 -8.320312 11.46875 -7.875 C 11.3125 -7.425781 11.234375 -6.929688 11.234375 -6.390625 L 11.234375 0 L 8.515625 0 L 8.515625 -7.828125 C 8.515625 -8.492188 8.410156 -9.023438 8.203125 -9.421875 C 7.992188 -9.816406 7.632812 -10.015625 7.125 -10.015625 C 6.800781 -10.015625 6.484375 -9.921875 6.171875 -9.734375 C 5.867188 -9.546875 5.59375 -9.273438 5.34375 -8.921875 C 5.09375 -8.578125 4.890625 -8.148438 4.734375 -7.640625 C 4.585938 -7.140625 4.515625 -6.578125 4.515625 -5.953125 L 4.515625 0 L 1.78125 0 L 1.78125 -6.046875 C 1.78125 -7.003906 1.710938 -7.804688 1.578125 -8.453125 C 1.453125 -9.109375 1.316406 -9.632812 1.171875 -10.03125 C 0.992188 -10.5 0.800781 -10.875 0.59375 -11.15625 L 2.765625 -12.03125 C 2.921875 -11.851562 3.078125 -11.632812 3.234375 -11.375 C 3.367188 -11.15625 3.5 -10.878906 3.625 -10.546875 C 3.75 -10.222656 3.851562 -9.851562 3.9375 -9.4375 C 4.332031 -10.394531 4.894531 -11.082031 5.625 -11.5 C 6.351562 -11.925781 7.125 -12.140625 7.9375 -12.140625 C 8.757812 -12.140625 9.394531 -11.929688 9.84375 -11.515625 C 10.300781 -11.097656 10.644531 -10.5625 10.875 -9.90625 C 11.300781 -10.707031 11.851562 -11.28125 12.53125 -11.625 C 13.21875 -11.96875 13.9375 -12.140625 14.6875 -12.140625 C 15.3125 -12.140625 15.832031 -12.039062 16.25 -11.84375 C 16.675781 -11.644531 17.015625 -11.363281 17.265625 -11 C 17.515625 -10.644531 17.691406 -10.210938 17.796875 -9.703125 C 17.910156 -9.203125 17.96875 -8.640625 17.96875 -8.015625 L 17.96875 0 Z M 15.265625 0 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(136.17553, 175.900008)">
                                    <g>
                                      <path d="M 0.84375 -5.6875 C 0.84375 -6.757812 0.988281 -7.703125 1.28125 -8.515625 C 1.582031 -9.335938 1.988281 -10.023438 2.5 -10.578125 C 3.019531 -11.128906 3.632812 -11.539062 4.34375 -11.8125 C 5.050781 -12.09375 5.8125 -12.234375 6.625 -12.234375 C 7.34375 -12.234375 7.953125 -12.144531 8.453125 -11.96875 C 8.960938 -11.800781 9.375 -11.5625 9.6875 -11.25 C 10.007812 -10.945312 10.242188 -10.585938 10.390625 -10.171875 C 10.546875 -9.753906 10.625 -9.304688 10.625 -8.828125 C 10.625 -8.253906 10.460938 -7.707031 10.140625 -7.1875 C 9.828125 -6.664062 9.367188 -6.207031 8.765625 -5.8125 C 8.171875 -5.425781 7.445312 -5.113281 6.59375 -4.875 C 5.75 -4.644531 4.800781 -4.523438 3.75 -4.515625 C 3.789062 -4.140625 3.863281 -3.785156 3.96875 -3.453125 C 4.070312 -3.128906 4.222656 -2.84375 4.421875 -2.59375 C 4.628906 -2.351562 4.890625 -2.160156 5.203125 -2.015625 C 5.523438 -1.867188 5.925781 -1.796875 6.40625 -1.796875 C 6.757812 -1.796875 7.132812 -1.835938 7.53125 -1.921875 C 7.9375 -2.003906 8.304688 -2.097656 8.640625 -2.203125 C 9.035156 -2.335938 9.425781 -2.484375 9.8125 -2.640625 L 10.53125 -0.9375 C 10.113281 -0.726562 9.664062 -0.546875 9.1875 -0.390625 C 8.769531 -0.242188 8.289062 -0.113281 7.75 0 C 7.207031 0.113281 6.632812 0.171875 6.03125 0.171875 C 5.09375 0.171875 4.296875 0.03125 3.640625 -0.25 C 2.984375 -0.53125 2.445312 -0.925781 2.03125 -1.4375 C 1.625 -1.945312 1.320312 -2.5625 1.125 -3.28125 C 0.9375 -4.007812 0.84375 -4.8125 0.84375 -5.6875 Z M 6.40625 -10.375 C 5.875 -10.375 5.4375 -10.25 5.09375 -10 C 4.75 -9.75 4.472656 -9.425781 4.265625 -9.03125 C 4.054688 -8.644531 3.910156 -8.207031 3.828125 -7.71875 C 3.742188 -7.226562 3.691406 -6.734375 3.671875 -6.234375 C 4.441406 -6.265625 5.09375 -6.363281 5.625 -6.53125 C 6.164062 -6.707031 6.601562 -6.914062 6.9375 -7.15625 C 7.269531 -7.40625 7.507812 -7.675781 7.65625 -7.96875 C 7.8125 -8.257812 7.890625 -8.546875 7.890625 -8.828125 C 7.890625 -9.296875 7.753906 -9.671875 7.484375 -9.953125 C 7.210938 -10.234375 6.851562 -10.375 6.40625 -10.375 Z M 6.40625 -10.375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(147.521969, 175.900008)">
                                    <g>
                                      <path d="M 4.109375 0.09375 C 3.191406 0.09375 2.515625 -0.15625 2.078125 -0.65625 C 1.648438 -1.164062 1.4375 -1.8125 1.4375 -2.59375 L 1.4375 -16.921875 L 4.171875 -17.421875 L 4.171875 -2.859375 C 4.171875 -2.484375 4.242188 -2.222656 4.390625 -2.078125 C 4.535156 -1.941406 4.742188 -1.875 5.015625 -1.875 C 5.171875 -1.875 5.328125 -1.878906 5.484375 -1.890625 C 5.640625 -1.910156 5.78125 -1.9375 5.90625 -1.96875 C 6.050781 -2 6.175781 -2.03125 6.28125 -2.0625 L 6.625 -0.34375 C 6.414062 -0.257812 6.179688 -0.1875 5.921875 -0.125 C 5.703125 -0.0625 5.441406 -0.0078125 5.140625 0.03125 C 4.835938 0.0703125 4.492188 0.09375 4.109375 0.09375 Z M 4.109375 0.09375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(154.502544, 175.900008)">
                                    <g>
                                      <path d="M 11.328125 -4.84375 C 11.328125 -4.363281 11.363281 -3.921875 11.4375 -3.515625 C 11.507812 -3.117188 11.585938 -2.722656 11.671875 -2.328125 C 11.765625 -1.941406 11.847656 -1.546875 11.921875 -1.140625 C 12.003906 -0.742188 12.046875 -0.304688 12.046875 0.171875 C 12.046875 1.867188 11.613281 3.128906 10.75 3.953125 C 9.882812 4.785156 8.71875 5.203125 7.25 5.203125 C 6.769531 5.203125 6.289062 5.15625 5.8125 5.0625 C 5.332031 4.976562 4.882812 4.878906 4.46875 4.765625 C 4.0625 4.660156 3.710938 4.550781 3.421875 4.4375 C 3.140625 4.320312 2.953125 4.242188 2.859375 4.203125 L 3.53125 2.109375 C 3.75 2.203125 4 2.300781 4.28125 2.40625 C 4.5625 2.507812 4.847656 2.609375 5.140625 2.703125 C 5.441406 2.804688 5.75 2.890625 6.0625 2.953125 C 6.382812 3.015625 6.703125 3.046875 7.015625 3.046875 C 7.910156 3.046875 8.554688 2.773438 8.953125 2.234375 C 9.347656 1.703125 9.546875 1.015625 9.546875 0.171875 C 9.546875 -0.597656 9.390625 -1.390625 9.078125 -2.203125 C 8.628906 -1.359375 8.03125 -0.753906 7.28125 -0.390625 C 6.539062 -0.0351562 5.757812 0.140625 4.9375 0.140625 C 3.675781 0.140625 2.773438 -0.222656 2.234375 -0.953125 C 1.703125 -1.691406 1.4375 -2.703125 1.4375 -3.984375 L 1.4375 -11.953125 L 4.171875 -11.953125 L 4.171875 -4.0625 C 4.171875 -3.382812 4.289062 -2.851562 4.53125 -2.46875 C 4.769531 -2.082031 5.179688 -1.890625 5.765625 -1.890625 C 6.066406 -1.890625 6.390625 -1.976562 6.734375 -2.15625 C 7.078125 -2.332031 7.390625 -2.578125 7.671875 -2.890625 C 7.953125 -3.203125 8.179688 -3.578125 8.359375 -4.015625 C 8.546875 -4.460938 8.640625 -4.941406 8.640625 -5.453125 L 8.640625 -11.953125 L 11.453125 -11.953125 Z M 11.328125 -4.84375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(167.408217, 175.900008)">
                                    <g>
                                      <path d="M 1.6875 -16.25 C 1.789062 -16.25 2.023438 -16.25 2.390625 -16.25 C 2.765625 -16.257812 3.179688 -16.265625 3.640625 -16.265625 C 4.109375 -16.265625 4.585938 -16.269531 5.078125 -16.28125 C 5.578125 -16.289062 6.015625 -16.296875 6.390625 -16.296875 C 9.109375 -16.296875 11.125 -15.617188 12.4375 -14.265625 C 13.75 -12.910156 14.40625 -10.898438 14.40625 -8.234375 C 14.40625 -5.554688 13.734375 -3.503906 12.390625 -2.078125 C 11.046875 -0.660156 8.941406 0.046875 6.078125 0.046875 C 5.578125 0.046875 5.085938 0.0390625 4.609375 0.03125 C 4.140625 0.03125 3.707031 0.03125 3.3125 0.03125 C 2.925781 0.03125 2.585938 0.0234375 2.296875 0.015625 C 2.015625 0.00390625 1.8125 0 1.6875 0 Z M 6.046875 -14.15625 C 5.679688 -14.15625 5.375 -14.148438 5.125 -14.140625 C 4.875 -14.140625 4.675781 -14.140625 4.53125 -14.140625 L 4.53125 -2.109375 C 4.707031 -2.097656 4.9375 -2.09375 5.21875 -2.09375 C 5.5 -2.09375 5.90625 -2.09375 6.4375 -2.09375 C 8.113281 -2.09375 9.34375 -2.582031 10.125 -3.5625 C 10.90625 -4.550781 11.296875 -6.019531 11.296875 -7.96875 C 11.296875 -8.894531 11.203125 -9.738281 11.015625 -10.5 C 10.835938 -11.257812 10.535156 -11.910156 10.109375 -12.453125 C 9.691406 -12.992188 9.148438 -13.410156 8.484375 -13.703125 C 7.816406 -14.003906 7.003906 -14.15625 6.046875 -14.15625 Z M 6.046875 -14.15625 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#2563eb" fill-opacity="1">
                                  <g transform="translate(182.832654, 175.900008)">
                                    <g>
                                      <path d="M 6.3125 -12.234375 C 8.15625 -12.234375 9.488281 -11.6875 10.3125 -10.59375 C 11.144531 -9.507812 11.5625 -8.019531 11.5625 -6.125 C 11.5625 -5.226562 11.445312 -4.390625 11.21875 -3.609375 C 11 -2.835938 10.660156 -2.164062 10.203125 -1.59375 C 9.753906 -1.03125 9.1875 -0.582031 8.5 -0.25 C 7.8125 0.0703125 7.007812 0.234375 6.09375 0.234375 C 5.1875 0.234375 4.398438 0.0976562 3.734375 -0.171875 C 3.066406 -0.453125 2.515625 -0.859375 2.078125 -1.390625 C 1.648438 -1.921875 1.335938 -2.5625 1.140625 -3.3125 C 0.941406 -4.0625 0.84375 -4.910156 0.84375 -5.859375 C 0.84375 -6.765625 0.953125 -7.601562 1.171875 -8.375 C 1.398438 -9.15625 1.738281 -9.828125 2.1875 -10.390625 C 2.644531 -10.960938 3.21875 -11.410156 3.90625 -11.734375 C 4.59375 -12.066406 5.394531 -12.234375 6.3125 -12.234375 Z M 6.078125 -10.21875 C 5.609375 -10.21875 5.222656 -10.113281 4.921875 -9.90625 C 4.628906 -9.695312 4.398438 -9.40625 4.234375 -9.03125 C 4.066406 -8.65625 3.953125 -8.210938 3.890625 -7.703125 C 3.828125 -7.203125 3.796875 -6.664062 3.796875 -6.09375 C 3.796875 -5.5 3.832031 -4.9375 3.90625 -4.40625 C 3.976562 -3.882812 4.109375 -3.425781 4.296875 -3.03125 C 4.484375 -2.644531 4.738281 -2.335938 5.0625 -2.109375 C 5.394531 -1.890625 5.820312 -1.78125 6.34375 -1.78125 C 6.800781 -1.78125 7.175781 -1.882812 7.46875 -2.09375 C 7.769531 -2.300781 8.003906 -2.59375 8.171875 -2.96875 C 8.335938 -3.34375 8.453125 -3.773438 8.515625 -4.265625 C 8.578125 -4.765625 8.609375 -5.300781 8.609375 -5.875 C 8.609375 -6.46875 8.570312 -7.03125 8.5 -7.5625 C 8.4375 -8.09375 8.304688 -8.554688 8.109375 -8.953125 C 7.921875 -9.347656 7.660156 -9.65625 7.328125 -9.875 C 7.003906 -10.101562 6.585938 -10.21875 6.078125 -10.21875 Z M 6.078125 -10.21875 "/>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <svg class="h-7 hidden dark:block" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" zoomAndPan="magnify" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="54.57 148.46 139.82 38.29">
                                <defs>
                                  <g/>
                                  <clipPath id="5d1dc4d30d">
                                    <path d="M 54.613281 148.5 L 92.863281 148.5 L 92.863281 186.75 L 54.613281 186.75 Z M 54.613281 148.5 " clip-rule="nonzero"/>
                                  </clipPath>
                                </defs>
                                <g clip-path="url(#5d1dc4d30d)">
                                  <path fill="#ffffff" d="M 84.6875 186.699219 L 62.703125 186.699219 C 58.210938 186.699219 54.570312 183.058594 54.570312 178.566406 L 54.570312 156.59375 C 54.570312 152.101562 58.210938 148.457031 62.703125 148.457031 L 84.679688 148.457031 C 89.171875 148.457031 92.8125 152.101562 92.8125 156.59375 L 92.8125 178.566406 C 92.8125 183.058594 89.171875 186.699219 84.6875 186.699219 Z M 84.6875 186.699219 " fill-opacity="1" fill-rule="nonzero"/>
                                </g>
                                <path fill="#2563eb" d="M 71.726562 162.816406 L 65.988281 162.816406 L 65.988281 159.667969 L 81.410156 159.667969 L 81.410156 162.816406 L 75.6875 162.816406 L 75.6875 175.976562 L 71.726562 175.976562 Z M 71.726562 162.816406 " fill-opacity="1" fill-rule="nonzero"/>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(98.801842, 175.900008)">
                                    <g>
                                      <path d="M 11.5625 -16.25 L 11.203125 -14.09375 L 7.171875 -14.09375 L 7.171875 0 L 4.34375 0 L 4.34375 -14.09375 L 0.234375 -14.09375 L 0.234375 -16.25 Z M 11.5625 -16.25 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(110.628051, 175.900008)">
                                    <g>
                                      <path d="M 4.078125 0.09375 C 3.234375 0.09375 2.585938 -0.15625 2.140625 -0.65625 C 1.691406 -1.164062 1.46875 -1.816406 1.46875 -2.609375 L 1.46875 -11.953125 L 4.203125 -11.953125 L 4.203125 -2.859375 C 4.203125 -2.484375 4.253906 -2.234375 4.359375 -2.109375 C 4.472656 -1.984375 4.644531 -1.921875 4.875 -1.921875 C 4.9375 -1.921875 5.003906 -1.921875 5.078125 -1.921875 C 5.148438 -1.921875 5.21875 -1.925781 5.28125 -1.9375 C 5.34375 -1.9375 5.414062 -1.945312 5.5 -1.96875 L 5.78125 -0.234375 C 5.664062 -0.171875 5.523438 -0.117188 5.359375 -0.078125 C 5.210938 -0.0234375 5.03125 0.015625 4.8125 0.046875 C 4.59375 0.078125 4.347656 0.09375 4.078125 0.09375 Z M 2.875 -17.28125 C 3.382812 -17.28125 3.773438 -17.128906 4.046875 -16.828125 C 4.328125 -16.523438 4.46875 -16.128906 4.46875 -15.640625 C 4.46875 -15.160156 4.328125 -14.757812 4.046875 -14.4375 C 3.765625 -14.125 3.351562 -13.96875 2.8125 -13.96875 C 2.300781 -13.96875 1.90625 -14.125 1.625 -14.4375 C 1.34375 -14.75 1.203125 -15.128906 1.203125 -15.578125 C 1.203125 -16.066406 1.34375 -16.472656 1.625 -16.796875 C 1.90625 -17.117188 2.320312 -17.28125 2.875 -17.28125 Z M 2.875 -17.28125 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(116.769042, 175.900008)">
                                    <g>
                                      <path d="M 15.265625 0 L 15.265625 -7.828125 C 15.265625 -8.492188 15.160156 -9.023438 14.953125 -9.421875 C 14.742188 -9.816406 14.382812 -10.015625 13.875 -10.015625 C 13.570312 -10.015625 13.265625 -9.925781 12.953125 -9.75 C 12.640625 -9.582031 12.351562 -9.335938 12.09375 -9.015625 C 11.84375 -8.703125 11.632812 -8.320312 11.46875 -7.875 C 11.3125 -7.425781 11.234375 -6.929688 11.234375 -6.390625 L 11.234375 0 L 8.515625 0 L 8.515625 -7.828125 C 8.515625 -8.492188 8.410156 -9.023438 8.203125 -9.421875 C 7.992188 -9.816406 7.632812 -10.015625 7.125 -10.015625 C 6.800781 -10.015625 6.484375 -9.921875 6.171875 -9.734375 C 5.867188 -9.546875 5.59375 -9.273438 5.34375 -8.921875 C 5.09375 -8.578125 4.890625 -8.148438 4.734375 -7.640625 C 4.585938 -7.140625 4.515625 -6.578125 4.515625 -5.953125 L 4.515625 0 L 1.78125 0 L 1.78125 -6.046875 C 1.78125 -7.003906 1.710938 -7.804688 1.578125 -8.453125 C 1.453125 -9.109375 1.316406 -9.632812 1.171875 -10.03125 C 0.992188 -10.5 0.800781 -10.875 0.59375 -11.15625 L 2.765625 -12.03125 C 2.921875 -11.851562 3.078125 -11.632812 3.234375 -11.375 C 3.367188 -11.15625 3.5 -10.878906 3.625 -10.546875 C 3.75 -10.222656 3.851562 -9.851562 3.9375 -9.4375 C 4.332031 -10.394531 4.894531 -11.082031 5.625 -11.5 C 6.351562 -11.925781 7.125 -12.140625 7.9375 -12.140625 C 8.757812 -12.140625 9.394531 -11.929688 9.84375 -11.515625 C 10.300781 -11.097656 10.644531 -10.5625 10.875 -9.90625 C 11.300781 -10.707031 11.851562 -11.28125 12.53125 -11.625 C 13.21875 -11.96875 13.9375 -12.140625 14.6875 -12.140625 C 15.3125 -12.140625 15.832031 -12.039062 16.25 -11.84375 C 16.675781 -11.644531 17.015625 -11.363281 17.265625 -11 C 17.515625 -10.644531 17.691406 -10.210938 17.796875 -9.703125 C 17.910156 -9.203125 17.96875 -8.640625 17.96875 -8.015625 L 17.96875 0 Z M 15.265625 0 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(136.17553, 175.900008)">
                                    <g>
                                      <path d="M 0.84375 -5.6875 C 0.84375 -6.757812 0.988281 -7.703125 1.28125 -8.515625 C 1.582031 -9.335938 1.988281 -10.023438 2.5 -10.578125 C 3.019531 -11.128906 3.632812 -11.539062 4.34375 -11.8125 C 5.050781 -12.09375 5.8125 -12.234375 6.625 -12.234375 C 7.34375 -12.234375 7.953125 -12.144531 8.453125 -11.96875 C 8.960938 -11.800781 9.375 -11.5625 9.6875 -11.25 C 10.007812 -10.945312 10.242188 -10.585938 10.390625 -10.171875 C 10.546875 -9.753906 10.625 -9.304688 10.625 -8.828125 C 10.625 -8.253906 10.460938 -7.707031 10.140625 -7.1875 C 9.828125 -6.664062 9.367188 -6.207031 8.765625 -5.8125 C 8.171875 -5.425781 7.445312 -5.113281 6.59375 -4.875 C 5.75 -4.644531 4.800781 -4.523438 3.75 -4.515625 C 3.789062 -4.140625 3.863281 -3.785156 3.96875 -3.453125 C 4.070312 -3.128906 4.222656 -2.84375 4.421875 -2.59375 C 4.628906 -2.351562 4.890625 -2.160156 5.203125 -2.015625 C 5.523438 -1.867188 5.925781 -1.796875 6.40625 -1.796875 C 6.757812 -1.796875 7.132812 -1.835938 7.53125 -1.921875 C 7.9375 -2.003906 8.304688 -2.097656 8.640625 -2.203125 C 9.035156 -2.335938 9.425781 -2.484375 9.8125 -2.640625 L 10.53125 -0.9375 C 10.113281 -0.726562 9.664062 -0.546875 9.1875 -0.390625 C 8.769531 -0.242188 8.289062 -0.113281 7.75 0 C 7.207031 0.113281 6.632812 0.171875 6.03125 0.171875 C 5.09375 0.171875 4.296875 0.03125 3.640625 -0.25 C 2.984375 -0.53125 2.445312 -0.925781 2.03125 -1.4375 C 1.625 -1.945312 1.320312 -2.5625 1.125 -3.28125 C 0.9375 -4.007812 0.84375 -4.8125 0.84375 -5.6875 Z M 6.40625 -10.375 C 5.875 -10.375 5.4375 -10.25 5.09375 -10 C 4.75 -9.75 4.472656 -9.425781 4.265625 -9.03125 C 4.054688 -8.644531 3.910156 -8.207031 3.828125 -7.71875 C 3.742188 -7.226562 3.691406 -6.734375 3.671875 -6.234375 C 4.441406 -6.265625 5.09375 -6.363281 5.625 -6.53125 C 6.164062 -6.707031 6.601562 -6.914062 6.9375 -7.15625 C 7.269531 -7.40625 7.507812 -7.675781 7.65625 -7.96875 C 7.8125 -8.257812 7.890625 -8.546875 7.890625 -8.828125 C 7.890625 -9.296875 7.753906 -9.671875 7.484375 -9.953125 C 7.210938 -10.234375 6.851562 -10.375 6.40625 -10.375 Z M 6.40625 -10.375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(147.521969, 175.900008)">
                                    <g>
                                      <path d="M 4.109375 0.09375 C 3.191406 0.09375 2.515625 -0.15625 2.078125 -0.65625 C 1.648438 -1.164062 1.4375 -1.8125 1.4375 -2.59375 L 1.4375 -16.921875 L 4.171875 -17.421875 L 4.171875 -2.859375 C 4.171875 -2.484375 4.242188 -2.222656 4.390625 -2.078125 C 4.535156 -1.941406 4.742188 -1.875 5.015625 -1.875 C 5.171875 -1.875 5.328125 -1.878906 5.484375 -1.890625 C 5.640625 -1.910156 5.78125 -1.9375 5.90625 -1.96875 C 6.050781 -2 6.175781 -2.03125 6.28125 -2.0625 L 6.625 -0.34375 C 6.414062 -0.257812 6.179688 -0.1875 5.921875 -0.125 C 5.703125 -0.0625 5.441406 -0.0078125 5.140625 0.03125 C 4.835938 0.0703125 4.492188 0.09375 4.109375 0.09375 Z M 4.109375 0.09375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(154.502544, 175.900008)">
                                    <g>
                                      <path d="M 11.328125 -4.84375 C 11.328125 -4.363281 11.363281 -3.921875 11.4375 -3.515625 C 11.507812 -3.117188 11.585938 -2.722656 11.671875 -2.328125 C 11.765625 -1.941406 11.847656 -1.546875 11.921875 -1.140625 C 12.003906 -0.742188 12.046875 -0.304688 12.046875 0.171875 C 12.046875 1.867188 11.613281 3.128906 10.75 3.953125 C 9.882812 4.785156 8.71875 5.203125 7.25 5.203125 C 6.769531 5.203125 6.289062 5.15625 5.8125 5.0625 C 5.332031 4.976562 4.882812 4.878906 4.46875 4.765625 C 4.0625 4.660156 3.710938 4.550781 3.421875 4.4375 C 3.140625 4.320312 2.953125 4.242188 2.859375 4.203125 L 3.53125 2.109375 C 3.75 2.203125 4 2.300781 4.28125 2.40625 C 4.5625 2.507812 4.847656 2.609375 5.140625 2.703125 C 5.441406 2.804688 5.75 2.890625 6.0625 2.953125 C 6.382812 3.015625 6.703125 3.046875 7.015625 3.046875 C 7.910156 3.046875 8.554688 2.773438 8.953125 2.234375 C 9.347656 1.703125 9.546875 1.015625 9.546875 0.171875 C 9.546875 -0.597656 9.390625 -1.390625 9.078125 -2.203125 C 8.628906 -1.359375 8.03125 -0.753906 7.28125 -0.390625 C 6.539062 -0.0351562 5.757812 0.140625 4.9375 0.140625 C 3.675781 0.140625 2.773438 -0.222656 2.234375 -0.953125 C 1.703125 -1.691406 1.4375 -2.703125 1.4375 -3.984375 L 1.4375 -11.953125 L 4.171875 -11.953125 L 4.171875 -4.0625 C 4.171875 -3.382812 4.289062 -2.851562 4.53125 -2.46875 C 4.769531 -2.082031 5.179688 -1.890625 5.765625 -1.890625 C 6.066406 -1.890625 6.390625 -1.976562 6.734375 -2.15625 C 7.078125 -2.332031 7.390625 -2.578125 7.671875 -2.890625 C 7.953125 -3.203125 8.179688 -3.578125 8.359375 -4.015625 C 8.546875 -4.460938 8.640625 -4.941406 8.640625 -5.453125 L 8.640625 -11.953125 L 11.453125 -11.953125 Z M 11.328125 -4.84375 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(167.408217, 175.900008)">
                                    <g>
                                      <path d="M 1.6875 -16.25 C 1.789062 -16.25 2.023438 -16.25 2.390625 -16.25 C 2.765625 -16.257812 3.179688 -16.265625 3.640625 -16.265625 C 4.109375 -16.265625 4.585938 -16.269531 5.078125 -16.28125 C 5.578125 -16.289062 6.015625 -16.296875 6.390625 -16.296875 C 9.109375 -16.296875 11.125 -15.617188 12.4375 -14.265625 C 13.75 -12.910156 14.40625 -10.898438 14.40625 -8.234375 C 14.40625 -5.554688 13.734375 -3.503906 12.390625 -2.078125 C 11.046875 -0.660156 8.941406 0.046875 6.078125 0.046875 C 5.578125 0.046875 5.085938 0.0390625 4.609375 0.03125 C 4.140625 0.03125 3.707031 0.03125 3.3125 0.03125 C 2.925781 0.03125 2.585938 0.0234375 2.296875 0.015625 C 2.015625 0.00390625 1.8125 0 1.6875 0 Z M 6.046875 -14.15625 C 5.679688 -14.15625 5.375 -14.148438 5.125 -14.140625 C 4.875 -14.140625 4.675781 -14.140625 4.53125 -14.140625 L 4.53125 -2.109375 C 4.707031 -2.097656 4.9375 -2.09375 5.21875 -2.09375 C 5.5 -2.09375 5.90625 -2.09375 6.4375 -2.09375 C 8.113281 -2.09375 9.34375 -2.582031 10.125 -3.5625 C 10.90625 -4.550781 11.296875 -6.019531 11.296875 -7.96875 C 11.296875 -8.894531 11.203125 -9.738281 11.015625 -10.5 C 10.835938 -11.257812 10.535156 -11.910156 10.109375 -12.453125 C 9.691406 -12.992188 9.148438 -13.410156 8.484375 -13.703125 C 7.816406 -14.003906 7.003906 -14.15625 6.046875 -14.15625 Z M 6.046875 -14.15625 "/>
                                    </g>
                                  </g>
                                </g>
                                <g fill="#ffffff" fill-opacity="1">
                                  <g transform="translate(182.832654, 175.900008)">
                                    <g>
                                      <path d="M 6.3125 -12.234375 C 8.15625 -12.234375 9.488281 -11.6875 10.3125 -10.59375 C 11.144531 -9.507812 11.5625 -8.019531 11.5625 -6.125 C 11.5625 -5.226562 11.445312 -4.390625 11.21875 -3.609375 C 11 -2.835938 10.660156 -2.164062 10.203125 -1.59375 C 9.753906 -1.03125 9.1875 -0.582031 8.5 -0.25 C 7.8125 0.0703125 7.007812 0.234375 6.09375 0.234375 C 5.1875 0.234375 4.398438 0.0976562 3.734375 -0.171875 C 3.066406 -0.453125 2.515625 -0.859375 2.078125 -1.390625 C 1.648438 -1.921875 1.335938 -2.5625 1.140625 -3.3125 C 0.941406 -4.0625 0.84375 -4.910156 0.84375 -5.859375 C 0.84375 -6.765625 0.953125 -7.601562 1.171875 -8.375 C 1.398438 -9.15625 1.738281 -9.828125 2.1875 -10.390625 C 2.644531 -10.960938 3.21875 -11.410156 3.90625 -11.734375 C 4.59375 -12.066406 5.394531 -12.234375 6.3125 -12.234375 Z M 6.078125 -10.21875 C 5.609375 -10.21875 5.222656 -10.113281 4.921875 -9.90625 C 4.628906 -9.695312 4.398438 -9.40625 4.234375 -9.03125 C 4.066406 -8.65625 3.953125 -8.210938 3.890625 -7.703125 C 3.828125 -7.203125 3.796875 -6.664062 3.796875 -6.09375 C 3.796875 -5.5 3.832031 -4.9375 3.90625 -4.40625 C 3.976562 -3.882812 4.109375 -3.425781 4.296875 -3.03125 C 4.484375 -2.644531 4.738281 -2.335938 5.0625 -2.109375 C 5.394531 -1.890625 5.820312 -1.78125 6.34375 -1.78125 C 6.800781 -1.78125 7.175781 -1.882812 7.46875 -2.09375 C 7.769531 -2.300781 8.003906 -2.59375 8.171875 -2.96875 C 8.335938 -3.34375 8.453125 -3.773438 8.515625 -4.265625 C 8.578125 -4.765625 8.609375 -5.300781 8.609375 -5.875 C 8.609375 -6.46875 8.570312 -7.03125 8.5 -7.5625 C 8.4375 -8.09375 8.304688 -8.554688 8.109375 -8.953125 C 7.921875 -9.347656 7.660156 -9.65625 7.328125 -9.875 C 7.003906 -10.101562 6.585938 -10.21875 6.078125 -10.21875 Z M 6.078125 -10.21875 "/>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </a>
                        </div>
                    </div>
                </div>
                
                <div>
                  <troubleshoot :current_attendee="current_attendee"></troubleshoot>
                </div>
              </div>
              
            </div>
            <div :class="{ 'hidden': showForm, 'flex w-full md:w-3/5 col-span-2 h-full md:h-[99.9%]': date !== '' , 'w-full md:w-3/5': date === ''} ">
              <div id="timelydo_public_event_date_selection" :class="{ 'sm:w-7/12 hidden sm:block pl-5': date !== '', 'w-full w-full md:w-10/12 lg:w-9/12 pl-5 mx-auto': date === '' }" class="pt-6 pb-8 h-full md:h-[99.9%] md:pb-0 col-span-2">
                <div class="flex items-center flex-row justify-between w-full mt-2 mb-0 dark:text-gray-400">
                  <p class="font-semibold">
                 
                    <span class="hidden md:inline">{{ I18N.application.events.day_and_time }}</span>
                    <span class="md:hidden">{{ I18N.application.events.select_day }}</span>
                  </p>
                                       
                  <label id="timelydo_public_event_is24hour_toggle" class="relative inline-flex items-center cursor-pointer mr-7">
                    <input type="checkbox" v-model="is24Hour" class="sr-only peer" @change="updateTimeFormat">
                    <div id="toggleIcon" class="w-10 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer peer-checked:after:translate-x-[110%] peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:left-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all peer-checked:bg-blue-600"></div>
                    <span class="ml-1.5 text-sm text-gray-900 whitespace-nowrap dark:text-gray-400">{{ I18N.website_content.account_settings['24_hours'] }}</span>
                  </label>
                </div>
                
                
                <div>
                  <v-date-picker :attributes="calendarAttrs" 
                               :locale="CURRENT_LOCALE"
                               class="mt-5 -ml-3.5 public-calendar"
                               :class="{ 'public-calendar-date-selected': date !== '', 'public-calendar-date-unselected': date === '' }" 
                               v-model="date"
                               :is-dark="isDark"
                               :min-date='new Date()'
                               :max-date='DaysFromNowOn(diableAllDatesAfterXDays)'
                               :disabled-dates='notAvailableSlotDaysforSelectedMonth'
                               title-position="left"
                               @update:from-page="calendarPageChange" />
                               
                  <div class="-mt-80 bg-gray-50/70 h-[315px] -ml-3.5 mr-4 relative z-[9999] mb-8 custom-loader dark:bg-gray-600/80" 
                  id="custom-loader-id"></div>
                </div>
                                                   
                <div class="flex flex-col-reverse w-full mt-1 pr-8 mb-4">
                  <div class="relative">
                    <p class="font-semibold text-sm mb-3 dark:text-gray-400">{{ I18N.application.onboarding.timezone }}</p>
                                  
                    <button @click="toggleTimezoneResults" 
                            class="text-sm text-gray-700 hover:bg-gray-200 rounded relative flex w-full cursor-pointer items-center py-2 px-2 text-left dark:text-gray-400 dark:hover:bg-gray-600" 
                            id="searchButton" 
                            type="button" 
                            aria-haspopup="menu" 
                            aria-expanded="false">
                      <div class="grow truncate flex items-center">
                        <svg class="w-4 h-4 mr-2 fill-gray-900 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"></path>
                        </svg>
                        
                        <div class="h-5">{{userTimeZoneFormatted}}</div>
                      </div>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400">
                        <div aria-hidden="true">
                          <svg class="feather feather-chevron-down" fill="none" height="16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>
                      </div>
                    </button>
                  </div>
    
                  <div :class="{ 'hidden': timezone_is_hidden }" class="mb-10 rounded-lg bg-white/80 shadow-lg ring-1 ring-black ring-opacity-5 backdrop-blur-sm focus:outline-none absolute z-30 mt-1 max-h-72 overflow-y-auto flex w-[76vw] sm:max-w-[325px] md:min-w-[355px] flex-col mt-1 dark:bg-gray-600/80 dark:text-gray-400" 
                  aria-labelledby="headlessui-menu-button-1"
                  role="menu" tabindex="0" 
                  id="searchDropdown">
                  
                    <div class="flex shrink-0 items-center space-x-2 border-b pl-2.5"
                     role="none">
                      <div class="shrink-0 text-gray-400 dark:text-gray-400" role="none">
                        <svg class="feather feather-search" fill="none" height="16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg" role="none">
                          <circle cx="11" cy="11" r="8" role="none"></circle>
                          <line x1="21" x2="16.65" y1="21" y2="16.65" role="none"></line>
                        </svg>
                      </div>
                      
                      <input autocapitalize="off" 
                             autocomplete="off" 
                             autocorrect="off" 
                             class="rounded-md-t w-full border-none bg-transparent py-3 pl-1 pr-3 ring-0 focus:ring-0 active:ring-0 sm:text-sm sm:leading-5 dark:text-gray-400 dark:placeholder-gray-300" 
                             placeholder="Search by time zone" 
                             spellcheck="false" 
                             type="text" 
                             v-model="searchTimezoneTerm"
                             role="none">
                    </div>
                    
                    <div class="grow overflow-y-auto py-1" role="none">
                      <button class="relative block w-full py-2 pl-4 md:pl-10 pr-4 text-left text-sm" 
                              v-for="timezone in filteredTimeZones" 
                              :key="timezone.name"
                              type="button"
                              role="menuitem" 
                              tabindex="-1"
                              @click="setAttendeeTimeZone(timezone)"
                              data-headlessui-state="">
                        <div class="flex grow items-center space-x-2 tabular-nums">
                          <div class="rounded-full bg-gray-900 bg-opacity-10 px-2 py-px text-xs font-medium text-gray-600 dark:text-gray-400 dark:bg-gray-300 dark:bg-opacity-10">
                          {{ timezone.offset }}
                          </div>
                          <div class="text-gray-900 grow dark:text-gray-400">{{ timezone.name }}</div>
                          <div class="text-gray-600 dark:text-gray-400">
                            <time class="whitespace-nowrap">{{ timezone.time }}</time>
                          </div>
                        </div>
                      </button>
                     
                    </div>
                  </div>
                </div>  
              </div>
              
              <div :class="{ 'w-full sm:w-5/12 h-[99.9%] overflow-hidden flex flex-col items-center dark:text-gray-400': date !== '' }" v-if="date !== ''">
                <h4 v-if="date" class="sm:hidden text-center text-2xl font-bold mt-6">{{ I18N.application.events.select_time }}</h4>
                
                <p v-if="date" class="sm:hidden text-center font-light text-sm mt-3">{{ I18N.application.new_event.duration }}: 30 min</p>
                
                <div class="flex justify-center sm:justify-start sm:pl-3 w-full text-left md:pt-6 mb-2" v-if="date !== ''">
                  <p class="mt-2 text-gray-600 text-sm dark:text-gray-400"> {{ uiDate }} </p>
                </div>
              
                <div v-if="date !== ''" class="mb-10 sm:mb-0 w-full space-y-3 text-blue-600 font-semibold text-sm sm:overflow-y-auto scrollbar-style sm:h-[68vh] pt-2 px-2 sm:pl-1 sm:pr-3 z-10 pb-5 dark:text-gray-400">  
  <!--              <div class="flex items-center justify-center sm:justify-start mb-4">-->
  <!--                  <label for="slots" class="flex items-center">-->
  <!--                    <input id="slots" type="checkbox" class="w-4 h-4 ml-1 text-blue-600 bg-gray-100 border-gray-300 rounded">-->
  <!--                    <p class="ml-2 text-sm font-normal text-gray-600">Slots you're available</p>-->
  <!--                  </label>-->
  <!--              </div>-->
  <!--              <div class="flex flex-col items-center justify-center sm:items-start sm:justify-start mb-4">-->
  <!--                <div class="flex items-center">-->
  <!--                  <input disabled id="disabled-slots" type="checkbox" class="w-4 h-4 ml-1 text-blue-600 bg-gray-100 border-gray-300 rounded">-->
  <!--                  <label for="disabled-slots" class="ml-2 text-sm font-normal text-gray-400">Slots you're available</label>-->
  <!--                </div>-->
  <!--                  <p class="text-gray-600 text-xs font-normal ml-7 ">Login to use this feature</p>-->
  <!--              </div>-->
  
                <div class="flex gap-1"
                     v-for="(availability, index) in selectedDateAvailabilities" :key="index">
                  <div @click="selectSlot(availability)" 
                       :class="selectSlotBtnClass(availability)" 
                       class="transition-all timelydo-slot-available  flex items-center justify-center duration-400 py-3 text-center rounded dark:border-gray-400">
                       <span v-if="availability['12_hours']['c_avb']">
                            <svg class="fill-blue-500 w-3 h-3 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z"></path></svg>
                       </span>
                       {{ availability[attendee.time_format]['start_at'] }} - {{ availability[attendee.time_format]['end_at'] }}
                  </div>
                  <div :class="selectedConfirmButtonClass(availability)" @click="showForm = !showForm"
                   class="w-2/5 timelydo-slot-confirm cursor-pointer transition-all duration-400 py-3 text-center rounded">{{ I18N.website_content.public.confirm }}</div>
                </div>
                
              </div>
              </div>
            </div>
            
            <div :class="{ 'hidden': !showForm }" class="sm:w-3/5 mx-auto col-span-2 overflow-y-auto scrollbar-style transition transition-all duration-500  px-12 md:px-8 sm:px-4 py-6">
              <h4 class="font-semibold text-xl md:text-2xl mt-1.5 tracking-tight dark:text-gray-400">{{ I18N.application.events.enter_details }}</h4>
              
              <form class="mt-5 space-y-5 mb-5 sm:mb-0 w-full md:w-2/3 md:max-w-[500px]" @submit.prevent="submitBookingForm" @keydown.enter.prevent="">
                <div>
                  <span class="flex justify-between">
                    <p class="text-red-600 text-sm" v-if="attendee_errors.full_name"> {{ attendee_errors.full_name }} </p>
                  </span>
                  <TimelydoInput :value="attendee.full_name" 
                                    @input="updateInternalFieldsData"
                                    :placeholder="I18N.application.events.name" 
                                    inputClasses="w-full"
                                    name="attendee[full_name]" 
                                    :opts="{id: 'attendee_name', required: true}">              
                  </TimelydoInput>
                </div>
                
                <div>
                  <span class="flex justify-between">
                    <p class="text-red-600 text-sm" v-if="attendee_errors.email"> {{ attendee_errors.email }} </p>
                  </span>
                  <TimelydoInput :value="attendee.email" 
                                    @input="updateInternalFieldsData"
                                    :placeholder="I18N.application.events.email" 
                                    inputClasses="w-full"
                                    name="attendee[email]" 
                                    :opts="{id: 'attendee_email', required: true}">              
                  </TimelydoInput>
                  
                  <div v-show="current_event.enable_guest_emails" class="mt-2">
                    <GuestEmails :limit="current_event.guest_emails_limit" @guestEmailsChanged="updateGuestEmails" :guest_emails="existing_guest_emails"></GuestEmails>
                  </div>
                  <div v-if="invalid_email_exist">
                    <p class="text-red-600 font-medium mt-1 text-sm">{{ I18N.application.new_event.invalid_email_added }}</p>
                  </div>
                  <div v-show="show_questions" class="mt-5">
                    <PublicEventQuestions ref="publicEventQuestions"></PublicEventQuestions>
                  </div>
                </div>
  
                <div v-if="current_event.location.name === 'phone_call' && current_event.location.phone_call.selected_option === 'host_will_call_invitee'">
                  <TimelydoInput :value="booking_details.location_details.phone_call.invitee_contact_number" 
                                    @input="updateInternalFieldsData"
                                    :placeholder="I18N.application.events.phone_number" 
                                    inputClasses="w-full"
                                    name="phone_call[invitee_contact_number]" 
                                    :opts="{id: 'phone_number', required: true}">              
                  </TimelydoInput>
                </div>
                
                <div v-if="current_event.location.name === 'ask_invitee'">
                  <TimelydoTextArea :value="booking_details.location_details.ask_invitee.location_given_by_attendee"
                                       @focusout="updateInternalFieldsData"
                                       rows="5" :placeholder="I18N.application.events.set_location" 
                                       name="ask_invitee[location_given_by_attendee]" 
                                       :opts="{id: 'location_given_by_attendee'}">
                  </TimelydoTextArea>
                </div>
                
                <div v-if="bookingError !== ''">
                  <p class="text-red-600 my-3 font-medium text-sm -mt-4 mb-0">{{ bookingError }}</p>
                </div>
                
                <button id="timelydo_public_event_schedule_btn" :class="[{ 'opacity-[.5]': Object.keys(attendee_errors).length !== 0 || invalid_email_exist }]" :disabled="Object.keys(attendee_errors).length !== 0 || invalid_email_exist"  type="submit" class="text-center w-full sm:w-fit bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 font-medium rounded-[5px]">
                  <span v-if="show_loading_in_schedule_event_btn">
                    <svg aria-hidden="true" class="inline w-4 h-4 mr-1 text-gray-200 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"/>
                    </svg>
                    <span v-if="reschedule === 'true'">
                      {{ I18N.website_content.public.rescheduling }}
                    </span>
                    <span v-else>
                      {{ I18N.website_content.public.scheduling }}
                    </span>
                  </span> 
                             
                  <span v-else>
                    <span v-if="reschedule === 'true'">
                      {{ I18N.website_content.public.reschedule_event }}
                    </span>
                    <span v-else>  
                      {{ I18N.website_content.public.schedule_event }}
                    </span>
                  </span>
                
                </button>
              </form>
            </div>
          </div>
        </div>
        </section>
      </div>
    </div>
    
</template>

<script>
import Formatting from "controllers/vue_components/mixins/formatting"
import Constants from "controllers/vue_components/mixins/constants"
import RequestMixin from "controllers/vue_components/mixins/request"
import GuestEmails from "controllers/vue_components/fields/guest_emails_public_event"
import SocialIcons from "controllers/vue_components/events/social_icon"
import TimelydoTextArea from "controllers/vue_components/fields/timelydo_textarea"
import TimelydoInput from "controllers/vue_components/fields/timelydo_input"
import PublicEventQuestions from "controllers/vue_components/questions/public_event_form_questions"

export default {
  name: 'PublicEvent',
  props: ['event', 'current_attendee', 'time_zone_list', 'branding_json', 'social_library', 'profile_path', 'profile_pic', 'reschedule', 'rescheduling_data', 'embeded_widget', 'custom_template_as_json' ,'guest_emails'],
  mixins: [Formatting, Constants, RequestMixin],
  components: {
    SocialIcons, GuestEmails, TimelydoTextArea, TimelydoInput, PublicEventQuestions
  },
  data() {
    return {
      branding: {},
      custom_template: {},
      social_library_list: [],
      attendee_errors: {},
      show_loading_in_schedule_event_btn: false,
      date: '',
      current_event: {},
      time_zones: [],
      searchTimezoneTerm: '',
      showForm: false,
      is24Hour: false,
      showGuestEmails: false,
      timezone_is_hidden: true,
      userTimeZoneFormatted: '',
      slots_availability: {},
      isLoggedinAttendee: false,
      availabilitiesFetchingCount: 0,
      bookingError: '',
      calendar_page: {
        month: (new Date().getMonth() + 1),
        year: (new Date().getFullYear()),
      },
      attendee: {
        full_name: '',
        email: '',
        timezone: '',
        time_format: '12_hours'
      },
      booking_details: {
        selected_slot: '',
        location_details: {}
      },
      parsed_rescheduling_data: {},
      isDark: document.documentElement.classList.contains('dark'),
      guestEmails: [],
      existing_guest_emails: [],
      invalid_email_exist: false,
      show_questions: false
    };
  },
  watch: {
    date(newValue, oldValue) {
      // TODO: NEED TO FIND THE PROPER REASON WHY IT'S HAPPENING
      // TODO: TESTCASE: ON DOUBLE CLICK OF A DATE SLOTS ARE VANASHING
      // TODO: ========== CHEEPI START ==============

      if(newValue == null) {
        this.date = oldValue;
      }

      // TODO: ========== CHEEPI END ==============

      this.bookingError = ''
      this.booking_details.selected_slot = ''
      this.fetchAvailabilities();
    },

    'attendee.full_name'(newValue) {
      if(newValue === null || newValue === undefined || newValue.trim() === "") {
        this.attendee_errors.full_name = this.I18N.validations.full_name_cant_be_blank
      } else {
        delete this.attendee_errors.full_name;
      }
    },
    'attendee.email'(newValue) {
      if(newValue === null || newValue === undefined || newValue.trim() === "") {
        this.attendee_errors.email = this.I18N.validations.email_cant_be_blank
      } else {
        delete this.attendee_errors.email;
      }
    }
  },
  methods: {
    updateGuestEmails(newGuestEmails, invalid_email_exist){
      this.guestEmails = newGuestEmails
      this.invalid_email_exist = invalid_email_exist
      this.$forceUpdate();
    },
    updateTimeFormat() {
      if (this.attendee.time_format === '12_hours') {
        this.attendee.time_format = '24_hours'
      } else {
        this.attendee.time_format = '12_hours'
      }
    },

    currentCalendarStartDate(action) {
      if (action === 'month_number') {
        return this.calendar_page.month
      }

      if (action === 'year_number') {
        return this.calendar_page.year
      }

      let str_date = `1-${this.calendar_page.month}-${this.calendar_page.year}`
      if (action === 'str') {
        return str_date
      }

      let date_obj = this.strDatetoObject(str_date)
      if (action === 'date_object') {
        return date_obj
      }

      if (action === 'month_name') {
        let monthName = date_obj.toLocaleString('default', {month: 'long'});
        return monthName.toLowerCase();
      }
    },

    async fetchAvailabilities() {
      let available_months = Object.keys(this.slots_availability)
      if (available_months.includes(this.currentCalendarStartDate('month_name'))) {
        // Data already exists in the array so don't need to do anything
        return
      }

      let el_a = document.getElementById('custom-loader-id')
      if (el_a) {
        el_a.classList.remove("hidden")
      }

      this.availabilitiesFetchingCount += 1
      try {
        // We were facing an issue that Tokelau Is. was considered as a new route because of dot(.) at the end
        // so we need to check if location has dot(.) at then end then remove it. (only from end)
        /////////// CODE STARTING TO REMOVE DOT (.) FROM END ////////
        let location_name = this.attendee.timezone.name
        if (location_name.endsWith(".")) {
          location_name = location_name.slice(0, -1); // Remove the last character
          location_name = `${location_name}__dot__` // Add __dot__ at the end to make it work
        }
        /////////// CODE ENDED TO REMOVE DOT (.) FROM END ////////
        let end_point = `/api/${this.current_event.creator.url}/${this.current_event.url}/availabilities/${this.currentCalendarStartDate('str')}/timezone/${location_name}`
        let response = await this.axiosRequest('GET', end_point, {}, false)
        if (response.js_error == false && response.response.success) {
          let month_name = Object.keys(response.response.data.available_slots)[0];
          this.slots_availability[month_name] = response.response.data.available_slots[month_name];
          let el = document.getElementById('custom-loader-id')
          if (el) {
            el.classList.add("hidden")
          }
        }
      } catch (error) {
        console.error(error);
      }
      ;
    },

    async submitBookingForm() {
      this.show_loading_in_schedule_event_btn = true
      this.bookingError = ''
      let api_end_point = ''
      let data_set = {
        attendee: this.attendee,
        booking_details: this.booking_details,
        guest_emails: this.guestEmails
      }

      try {
        let base_url = `/api/${this.current_event.creator.url}/${this.current_event.url}`
        if (this.isRescheduleRequest) {
          api_end_point = `${base_url}/bookings/${this.parsed_rescheduling_data.id}/submit_reschedule_booking_form`
        } else {
          api_end_point = `${base_url}/add_booking`
          if(this.embeded_widget === 'true') {
            api_end_point = api_end_point + '?embed=true'
          }
        }

        let resp = await this.axiosRequest('POST', api_end_point, data_set, false)
        if (resp.js_error == false && resp.response.success) {
          if (resp.response.data.enable_external_payment === true) {
            window.location.href =  resp.response.data.external_payment_page_url + `?booking_id=${resp.response.data.id}`
          } else {
            let redirect_url = `/public/bookings/${resp.response.data.id}`
            if(this.embeded_widget === 'true') {
              redirect_url = redirect_url + '/embed'
            }
            window.location.href = redirect_url
          }
        } else {
          this.show_loading_in_schedule_event_btn = false
          this.bookingError = resp.error.data.message
        }

      } catch (error) {
        console.error(error);
      }
    },

    setAttendeeTimeZoneFormatted(zone) {
      this.userTimeZoneFormatted = `(GMT${zone.offset}) ${zone.name}`
    },

    setAttendeeTimeZone(timezone) {
      this.attendee.timezone = timezone
      this.setAttendeeTimeZoneFormatted(timezone)
      this.timezone_is_hidden = true
      this.slots_availability = {}
      if (this.availabilitiesFetchingCount > 0) {
        this.fetchAvailabilities()
      }
      this.searchTimezoneTerm = ''
    },

    selectSlot(slot) {
      this.booking_details.selected_slot = slot;
    },

    selectSlotBtnClass(current_slot) {
      let non_selected_class = 'cursor-pointer ring-1 ring-blue-400 w-full hover:ring-blue-600 hover:ring-2 dark:ring-gray-200 dark:hover:ring-white';
      let selected_class = 'bg-neutral-500 text-white border-none w-2/3 sm:text-[13px]';

      if (this.booking_details.selected_slot === '') {
        return non_selected_class
      }

      if (this.booking_details.selected_slot.utc_minutes.start_at === current_slot.utc_minutes.start_at) {
        return selected_class
      } else {
        return non_selected_class
      }
    },

    selectedConfirmButtonClass(current_slot) {
      let non_selected_class = 'hidden';
      let selected_class = 'bg-blue-600 text-white border-none';

      if (this.booking_details.selected_slot === '') {
        return non_selected_class
      }

      if (this.booking_details.selected_slot.utc_minutes.start_at === current_slot.utc_minutes.start_at) {
        return selected_class
      } else {
        return non_selected_class
      }
    },

    toggleGuestEmails() {
      this.showGuestEmails = true;
    },

    backIconLink() {
      if (this.showForm === true) {
        this.showForm = false
      } else {
        window.location.href = this.creatorProfileURL
      }
    },

    toggleTimezoneResults() {
      this.timezone_is_hidden = !this.timezone_is_hidden;
    },

    calendarPageChange(event) {
      this.calendar_page = event;
      this.fetchAvailabilities()
    },

    async updateInternalFieldsData (e) {
      let [objectName, fieldName] = e.target.name.split('[').map(part => part.replace(']', ''));
      let fieldValue = e.target.value

      if (objectName == 'attendee') {
          this.attendee[fieldName]= fieldValue
      }

      if (objectName == 'booking_details') {
        this.booking_details[fieldName] = fieldValue
      }
      if (objectName == 'phone_call') {
        this.booking_details.location_details.phone_call.invitee_contact_number = fieldValue
      }
      if (objectName == 'ask_invitee') {
        this.booking_details.location_details.ask_invitee.location_given_by_attendee = fieldValue
      }
    },

  },

  computed: {
    profileHref(){
      if (this.current_event.is_public == true) {
        return this.embeded_widget == 'true' ? '/embed' + this.profile_path : this.profile_path;
      } else {
        return '';
      }
    },
    notAvailableSlotDaysforSelectedMonth() {
      let year = this.currentCalendarStartDate('year_number')
      let monthNumber = this.currentCalendarStartDate('month_number')
      let lastDayOfMonth = new Date(year, monthNumber + 1, 0);
      let datesOfMonth = [];
      for (let date = 1; date <= lastDayOfMonth.getDate(); date++) {
        let currentDate = new Date(year, monthNumber - 1, date);
        datesOfMonth.push(this.dateObjectToFormattedStr(currentDate));
      }

      let avb = this.availableSlotDaysforSelectedMonth.map(date => this.dateObjectToFormattedStr(date))
      let not_avb = datesOfMonth.filter(date => !avb.includes(date))
      return not_avb.map(date => this.strDatetoObject(date))
    },

    availableSlotDaysforSelectedMonth() {
      if (this.slots_availability[this.currentCalendarStartDate('month_name')] === undefined) {
        return [];
      }

      let days = Object.keys(this.slots_availability[this.currentCalendarStartDate('month_name')]);
      let dateObjects = [];
      days.forEach(dateString => {
        dateObjects.push(this.strDatetoObject(dateString));
      });
      return dateObjects
    },

    calendarAttrs() {
      let opts = [
        {
          key: 'today',
          dot: 'gray',
          dates: new Date()
        },
        {
          highlight: {
            color: 'blue',
            fillMode: 'light',
          },
          dates: this.availableSlotDaysforSelectedMonth,
        },
      ]

      return opts;
    },
    filteredTimeZones() {
      let tz = this.time_zones.filter(zone => zone.name.toLowerCase() === (this.searchTimezoneTerm.toLowerCase()));
      if (tz.length === 0)  {
        tz = this.time_zones.filter(zone => zone.name.toLowerCase().includes(this.searchTimezoneTerm.toLowerCase()));
      }

      return tz;
    },
    creatorProfileURL() {
      if(this.embeded_widget == 'true'){
        return `/embed/${this.current_event.creator.url}`
      } else {
        return `/${this.current_event.creator.url}`
      }
    },
    selectedDate() {
      if (this.date === '') {
        return new Date;
      } else {
        return this.date;
      }
    },

    formattedSelectedDate() {
      return this.dateObjectToFormattedStr(this.selectedDate)
    },

    // selectedMonthName() => 'february'
    selectedMonthName() {
      let monthName = this.selectedDate.toLocaleString('default', {month: 'long'});
      return monthName.toLowerCase();
    },

    selectedDateAvailabilities() {
      try {
        let avbs = this.slots_availability[this.selectedMonthName][this.formattedSelectedDate];
        return (avbs === undefined ? [] : avbs);
      } catch {
        return [];
      }
    },
    mainCardStyles() {
      let classes = ''

      if (this.showGuestEmails) {
        classes += 'my-8 '
      }

      // const emptyDate = this.embeded_widget === 'true' ? 'sm:min-h-screen w-full ' : 'sm:min-h-[73vh] w-full sm:w-11/12 md:w-10/12 xl:w-7/12';
      // const withDate = this.embeded_widget === 'true' ? 'lg:min-h-[83vh] w-full sm:w-11/12 md:w-11/12 lg:w-10/12 xl:w-full' : 'lg:min-h-[83vh] w-full sm:w-11/12 md:w-10/12 xl:w-9/12';
      //
      // classes += this.date === '' ? emptyDate : withDate

      return classes
    },
    // uiDate => 'February 26, 2023'
    uiDate() {
      if(this.selectedDate === null) {
        return '';
      };
      let options = {weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'};
      return this.selectedDate.toLocaleDateString(this.UI_LOCALE_NAME, options);
    },
    isRescheduleRequest() {
      if (this.rescheduling_data === undefined) {
        return false
      } else {
        return true
      }
    },
    cardPositionStyling() {
      if(this.embeded_widget !== 'true'){
        if (this.reschedule === 'false') {
          return '';
        }
      }
    }
  },
  created() {
    // this.embeded_widget = this.embed_mode === 'true'
    this.current_event = JSON.parse(this.event);
    this.custom_template = JSON.parse(this.custom_template_as_json);
    this.branding = JSON.parse(this.branding_json);
    this.social_library_list = JSON.parse(this.social_library);
    this.booking_details.location_details = this.current_event.location
    this.time_zones = JSON.parse(this.time_zone_list);
    this.existing_guest_emails = JSON.parse(this.guest_emails)

    if (this.current_attendee !== '') {
      // attendee is logged in so current user will be a attendee
      this.attendee = JSON.parse(this.current_attendee);
      this.searchTimezoneTerm = this.attendee.timezone;
      this.attendee.timezone = this.filteredTimeZones[0]
      if (this.attendee.time_format === '24_hours') {
        this.is24Hour = true
      }
      this.isLoggedinAttendee = true
    }


    if (this.attendee.timezone === '') {
      try {
        let user_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let user_city = user_timezone.split('/')[1].replace(/_/g, ' ')
        this.searchTimezoneTerm = user_city
        this.attendee.timezone = this.filteredTimeZones[0]
        if (this.attendee.timezone === undefined) {
          this.searchTimezoneTerm = 'UTC'
          this.attendee.timezone = this.filteredTimeZones[0]
        }
      } catch (error) {
        this.searchTimezoneTerm = 'UTC'
        this.attendee.timezone = this.filteredTimeZones[0]
      }
    }

    this.setAttendeeTimeZone(this.attendee.timezone)
    this.searchTimezoneTerm = ''

    if (this.isRescheduleRequest) {
      this.parsed_rescheduling_data = JSON.parse(this.rescheduling_data)
      this.attendee.full_name = this.parsed_rescheduling_data.attendee_name
      this.attendee.email = this.parsed_rescheduling_data.attendee_email
    }
    if (this.current_event.active_event_questions_blueprint.length > 0) {
      this.show_questions = true;

      this.$nextTick(() => {
        this.$refs.publicEventQuestions.updateData(this.current_event.active_event_questions_blueprint);
      });

    }
    console.log(this.current_event.active_event_questions_blueprint)
  }
};
</script>
